var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('HeaderComponent'),_c('router-view'),_c('notifications',{staticStyle:{"padding-top":"15px"},attrs:{"max":3,"position":"top center","group":"notify"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }